import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { CardTitle, Col, Modal, ModalBody, Row, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

import Select from "react-select"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import {
  createFollowUp,
  getLeads,
  getUsers,
  updateFollowUp,
  getAllInvestmentLead,
} from "store/actions"

import { useParams, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const FollowUpModal = ({
  show,
  onCloseClick,
  updateData,
  type,
}) => {
  const dispatch = useDispatch()
  const params = useParams()
  const location = useLocation()
  const isInvestmentLeadPage = location?.pathname?.includes('investment')

  const queryParams = new URLSearchParams(location.search)
  const queryId = queryParams.get("id")
  const currentId = params?.id || queryId

  const { isRole, isAnyRole } = useRole()
  const { allStaffs, allLeads, investmentLeads } = useSelector(state => ({
    allStaffs: state?.Members?.users?.users,
    allLeads: state?.Lead?.leads?.leads,
    investmentLeads: state?.InvestmentLead?.investmentLeads
  }))

  const [Staff, setStaff] = useState("Select Staff...")
  const [StaffId, setStaffId] = useState("")
  const [StaffSearch, setStaffSearch] = useState("")

  const [lead, setLead] = useState("Select Lead...")
  const [leaId, setLeadId] = useState("")
  const [leadSearch, setLeadSearch] = useState("")
  const [status, setStatus] = useState("")
  const [statusValue, setStatusValue] = useState("")
  const [scheduledDate, setScheduledDate] = useState(new Date())

  const [activeTab, setActiveTab] = useState(isInvestmentLeadPage ? "2" : "1")
  const [investmentLead, setInvestmentLead] = useState("Select Investment Lead...")
  const [investmentLeadId, setInvestmentLeadId] = useState("")
  const [investmentLeadSearch, setInvestmentLeadSearch] = useState("")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  useEffect(() => {
    setStatus(updateData?.status)
    setStatusValue(updateData?.status)
    if (updateData?.assignedDate) {
      setScheduledDate(new Date(updateData.assignedDate))
    } else {
      setScheduledDate(new Date())
    }
  }, [updateData])


  useEffect(() => {
    dispatch(getUsers("", "", StaffSearch, '', ""))
  }, [dispatch, StaffSearch])

  const handleRoleText = text => {
    if (text) {
      const addSpace = text?.replace(/([a-z])([A-Z])/g, "$1 $2")
      return addSpace?.charAt(0).toUpperCase() + addSpace?.slice(1).trim()
    } else return ""
  }

  const staffOptions = [
    {
      options: (allStaffs?.length >= 1 ? allStaffs : [])?.map(
        (result, index) => ({
          key: index,
          // label: result?.name,
          label: `${result?.name} (${result?.role
            ? handleRoleText(result?.memberRole)
            : handleRoleText(result?.role)
            })`,
          value: result?._id,
        })
      ),
    },
  ]

  const handleEntersStaffs = text => {
    setStaffSearch(text)
  }

  const handlerStaffsFinalValue = event => {
    setStaff(event?.label)
    setStaffId(event?.value)
  }

  useEffect(() => {
    if (updateData?._id) {
      setStaffId(updateData?.assignee?._id)
      setStaff(updateData?.assignee?.name)

      if (updateData?.investmentLead || (isInvestmentLeadPage && !updateData?.lead)) {
        setActiveTab("2")
        setInvestmentLeadId(updateData?.investmentLead?._id || updateData?.investmentLead)
        setInvestmentLead(updateData?.investmentLead?.name || "")
      } else {
        setActiveTab("1")
        setLeadId(updateData?.lead?._id || updateData?.lead)
        const label = `${updateData?.lead?.client?.name || ""}${updateData?.lead?.vehicle?.name
          ? " - " + updateData.lead.vehicle.name
          : ""
          }`.trim()

        setLead(label)
      }
    } else if (updateData?.investmentLead) {
      setActiveTab("2")
      setInvestmentLeadId(updateData?.investmentLead?._id || updateData?.investmentLead)
      setInvestmentLead(updateData?.investmentLead?.name || "")
    }
  }, [updateData, isInvestmentLeadPage])

  useEffect(() => {
    dispatch(getLeads("", "", "", leadSearch, "", "", "", "", "", ""))
  }, [dispatch, leadSearch])

  const leadOptions = [
    {
      options: (allLeads?.length >= 1 ? allLeads : [])?.map(
        (results, index) => ({
          key: index,
          label: `${results.client?.name} ${results.vehicle?.name ? "-" : ""} ${results.vehicle?.name || ""
            }`,
          value: results?._id,
        })
      ),
    },
  ]
  const handleEntersLead = text => {
    setLeadSearch(text)
  }

  useEffect(() => {
    if (isRole(ROLE_TYPES.SUPER_ADMIN) || isRole(ROLE_TYPES.BUSINESS_DEVELOPMENT_OFFICER)) {
      dispatch(getAllInvestmentLead(1, 10, investmentLeadSearch, {}))
    }
  }, [dispatch, investmentLeadSearch])

  const investmentLeadOptions = [
    {
      options: (investmentLeads?.investmentLeads?.length >= 1 ? investmentLeads?.investmentLeads : [])?.map(
        (results, index) => ({
          key: index,
          label: `${results?.name} ${results?.phone ? "(" + results?.phone + ")" : ""}`,
          value: results?._id,
        })
      ),
    },
  ]

  const handleEntersInvestmentLead = text => {
    setInvestmentLeadSearch(text)
  }

  const handlerInvestmentLeadFinalValue = event => {
    setInvestmentLead(event?.label)
    setInvestmentLeadId(event?.value)
  }

  const handlerLeadFinalValue = event => {
    setLead(event?.label)
    setLeadId(event?.value)
  }
  const resetForm = () => {
    setStaff("Select Staff...")
    setStaffId("")
    setStaffSearch("")

    setLead("Select Lead...")
    setLeadId("")
    setLeadSearch("")

    setInvestmentLead("Select Investment Lead...")
    setInvestmentLeadId("")
    setInvestmentLeadSearch("")
    setActiveTab(isInvestmentLeadPage ? "2" : "1")

    setStatus("")
    setStatusValue("")
    setScheduledDate(new Date())
  }

  const handleClose = () => {
    resetForm()
    onCloseClick()
  }

  const handleValidSubmit = (e, v) => {
    const followUpUpdate = {
      ...v,
      lead: activeTab === "1" ? (isInvestmentLeadPage ? (updateData?.lead?._id || null) : (currentId || leaId)) : null,
      investmentLead: activeTab === "2" ? (isInvestmentLeadPage ? (currentId || investmentLeadId || updateData?.investmentLead?._id) : (updateData?.investmentLead?._id || investmentLeadId)) : null,
      type: type,
      assignee: StaffId,
      status: statusValue,
      assignedDate: moment(scheduledDate).format("MM-DD-YYYY"),
    }

    if (updateData?._id) {
      dispatch(
        updateFollowUp(
          followUpUpdate,
          updateData?._id,
        )
      )
      handleClose()
    } else {
      const followUpCreate = {
        ...v,
        lead: activeTab === "1" ? (isInvestmentLeadPage ? (updateData?.lead?._id || null) : (currentId || leaId)) : null,
        investmentLead: activeTab === "2" ? (isInvestmentLeadPage ? (currentId || investmentLeadId || updateData?.investmentLead?._id) : (updateData?.investmentLead?._id || investmentLeadId)) : null,
        type: type,
        status: statusValue,
        assignee: StaffId,
        assignedDate: moment(scheduledDate).format("MM-DD-YYYY"),
      }
      dispatch(createFollowUp(followUpCreate, handleClose))
      handleClose()
    }
  }


  return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-center pb-3">
          <CardTitle className="mb-0">
            {updateData?._id ? "Edit FollowUp Task" : "FollowUp Task"}
          </CardTitle>

          {!params?.id && !updateData?.investmentLead && (
            <Nav tabs className="nav-tabs-custom mb-0">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer", fontSize: "12px", padding: "0.5rem 1rem" }}
                  className={classnames({
                    active: activeTab === "1",
                  })}
                  onClick={() => {
                    toggleTab("1")
                  }}
                >
                  <span className="d-block d-sm-none">
                    <i className="fas fa-home"></i>
                  </span>
                  <span className="d-none d-sm-block">Lead</span>
                </NavLink>
              </NavItem>
              {isAnyRole([
                ROLE_TYPES.SUPER_ADMIN,
                ROLE_TYPES.BUSINESS_DEVELOPMENT_OFFICER,
              ]) && <NavItem>
                  <NavLink
                    style={{ cursor: "pointer", fontSize: "12px", padding: "0.5rem 1rem" }}
                    className={classnames({
                      active: activeTab === "2",
                    })}
                    onClick={() => {
                      toggleTab("2")
                    }}
                  >
                    <span className="d-block d-sm-none">
                      <i className="far fa-user"></i>
                    </span>
                    <span className="d-none d-sm-block">Investment</span>
                  </NavLink>
                </NavItem>}
            </Nav>
          )}
        </div>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <Col className="col-12 my-2">
              <label>
                Task <span className="text-danger"> *</span>
              </label>
              <AvField
                name="title"
                type="textarea"
                placeholder="Enter your task"
                value={updateData?.title || updateData?.message || ""}
                rows="4"
                style={{ minHeight: "100px", resize: "vertical" }}
                required
                errorMessage="task is required"
              />
            </Col>
            <Col className="col-12 py-3">
              <div className="w-100 text-align-center">
                <label>Assignee</label>
                <Select
                  onInputChange={handleEntersStaffs}
                  value={Staff}
                  placeholder={Staff}
                  onChange={handlerStaffsFinalValue}
                  options={staffOptions}
                  classNamePrefix="select2-selection"
                  isLoading={false}
                />
              </div>
            </Col>
            {!params?.id && (
              <Col className="col-12 py-3">
                <div className="w-100 text-align-center">


                  {activeTab === "1" ? (
                    <div>
                      <label>
                        Lead
                      </label>
                      <Select
                        onInputChange={handleEntersLead}
                        value={lead}
                        placeholder={lead}
                        onChange={handlerLeadFinalValue}
                        options={leadOptions}
                        classNamePrefix="select2-selection"
                        isLoading={false}
                      />
                    </div>
                  ) : (
                    <div>
                      <label>
                        Investment Lead
                      </label>
                      <Select
                        onInputChange={handleEntersInvestmentLead}
                        value={investmentLead}
                        placeholder={investmentLead}
                        onChange={handlerInvestmentLeadFinalValue}
                        options={investmentLeadOptions}
                        classNamePrefix="select2-selection"
                        isLoading={false}
                      />
                    </div>
                  )}

                </div>
              </Col>
            )}
            <Col
              className=" mb-4"
              md={12}
            // md={updateData?._id ? 6 : 12}
            >
              <label>Scheduled Date</label>
              <Flatpickr
                className="form-control"
                placeholder="Select Date"
                value={scheduledDate}
                onChange={([date]) => setScheduledDate(date)}
                options={{
                  dateFormat: "d/m/Y",
                  allowInput: false,
                  disableMobile: true,
                }}
                style={{ cursor: "pointer", backgroundColor: "#fff" }}
              />
            </Col>
          </Row>

          {!updateData?._id ? (
            <>
              <Row></Row>
            </>
          ) : (
            ""
          )}

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal >
  )
}

FollowUpModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
  type: PropTypes.any,
}

export default FollowUpModal
